<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" :class="[reseller.deleted_at === null ? 'btn-danger' : 'btn-success']" @click.prevent="confirmDeleteRow()">
        <span v-if="reseller.deleted_at == null">
          <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Desabilitar Loja</span>
        </span>
        <span v-else>
          <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Habilitar Loja</span>
        </span>
      </d-button>
      <d-button size="sm" :class="[reseller.status === 0 ? 'btn-info' : 'btn-secondary']" @click.prevent="blockAccess" v-if="reseller.deleted_at == null">
        <span v-if="(reseller.status == 1)">
          <i class="fas fa-ban"></i><span class="d-none d-lg-inline"> Não indicar loja no site</span>
        </span>
        <span v-else>
          <i class="fas fa-check-circle"></i><span class="d-none d-lg-inline"> Liberar exibição no site</span>
        </span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_RESELLER_ } from '_modules/reseller/components/ResellerModel';

export default {
  name: 'reseller-buttons',
  props: {
    reseller: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    blockAccess() {
      this.$emit('blockAccess', this.reseller);
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_RESELLER_, this.reseller);
    },
  },
  mounted() {},
};
</script>
